// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CandidateUpgradeCheckModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 1;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent {
  background: var(--Foreground);
  width: 35rem;
  min-height: 20rem;
  border-radius: 0.625rem;
  padding: 0.75rem;
  color: var(--TextColor);
  position: relative;
  overflow: hidden;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeConvert {
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent p {
  text-align: center;
  font-size: 0.75rem;
  padding-top: 0.3rem;
  text-wrap: balance;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeCurrentMain {
  border: 0.125rem solid var(--Stroke);
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  align-items: center;
  margin-top: 1rem;
  gap: 0.5rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeCurrentMain .UpgradeCourt .UpgradeCurrentCheck {
  text-align: center;
  font-size: 0.6rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeCurrentMain .UpgradeCourt .UpgradeStandardCourt {
  font-weight: 700;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeCurrentMain .upgradeExpressCourt .UpgradeConvertedCheck {
  text-align: center;
  font-size: 0.6rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeCurrentMain .upgradeExpressCourt .UpgradeExpressCourt {
  font-weight: 700;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount {
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .RefDetails {
  display: flex;
  padding: 0.625rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .RefDetails .ReferenceDetails {
  flex: 1 1;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .RefDetails .ReferenceDetails .Reference {
  color: #9b9b9b;
  font-size: 1rem;
  font-weight: 600;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .RefDetails .ReferenceDetails .ReferenceNumber {
  color: Var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
  padding-left: 0.625rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .RefDetails .DateDetails .Date {
  color: #9b9b9b;
  font-size: 1rem;
  font-weight: 600;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .RefDetails .DateDetails .DateNumber {
  color: Var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
  padding-left: 0.625rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .TaxDetails {
  border-top: 0.0625rem solid var(--Stroke);
  padding: 0.625rem;
  border-bottom: 0.0625rem solid var(--Stroke);
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .TaxDetails p {
  display: flex;
  padding: 0.25rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .TaxDetails p .Taxable {
  flex: 1 1;
  color: #9b9b9b;
  font-size: 0.8rem;
  font-weight: 300;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .TaxDetails p .TaxableAmt {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--TextColor);
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .AmtToPay {
  padding: 0.5rem;
  display: flex;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .AmtToPay .AmountPay {
  color: var(--TextColor);
  flex: 1 1;
  font-size: 1rem;
  font-weight: 600;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .SplitAmount .AmtToPay .Amount {
  color: var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .PaymentType {
  display: flex;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .PaymentType .PaymentGateway {
  width: 16.5rem;
  height: 10rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
  padding: 0.625rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.25rem;
  cursor: pointer;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .PaymentType .PaymentGateway .WalletPayAmt {
  color: var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .PaymentType .PaymentGateway .PayViaWallet {
  color: var(--AccentColor);
  font-size: 1rem;
  font-weight: 700;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .PaymentType .PayWallet {
  width: 16.5rem;
  height: 10rem;
  margin-left: 0.5rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
  padding: 0.625rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.25rem;
  cursor: pointer;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .PaymentType .PayWallet .WalletPayAmt {
  color: var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .PaymentMet .PaymentType .PayWallet .PayViaWallet {
  color: var(--AccentColor);
  font-size: 1rem;
  font-weight: 700;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpdatedCost {
  border: 0.125rem solid #cccad4;
  border-radius: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.75rem;
  display: flex;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpdatedCost p {
  flex: 1 1;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 700;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeButton {
  margin-top: 1rem;
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeButton .UpgradeCancel {
  background: var(--Foreground);
  border-radius: 0.25rem;
  width: 6rem;
  height: 2rem;
  font-size: 0.75rem;
  color: var(--TextColor);
}
.CandidateUpgradeCheckModal .UpgradeCheckContent .UpgradeButton .UpgradeConfirm {
  background: var(--AccentColor);
  border-radius: 0.25rem;
  width: 6rem;
  height: 2rem;
  color: white;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/CandidateDetails/SubDetails/CandidateUpgradeModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;EACA,0BAAA;EACA,UAAA;AACF;AAAE;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;AADI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAGN;AADI;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAGN;AADI;EAGE,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AACN;AACQ;EACE,kBAAA;EACA,iBAAA;AACV;AACQ;EACE,gBAAA;AACV;AAMQ;EACE,kBAAA;EACA,iBAAA;AAJV;AAMQ;EACE,gBAAA;AAJV;AAQI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AANN;AAOM;EACE,qCAAA;EACA,uBAAA;AALR;AAMQ;EACE,aAAA;EACA,iBAAA;AAJV;AAKU;EACE,SAAA;AAHZ;AAIY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAFd;AAKY;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAHd;AAOY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AALd;AAQY;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AANd;AAUQ;EACE,yCAAA;EACA,iBAAA;EACA,4CAAA;AARV;AASU;EACE,aAAA;EACA,gBAAA;AAPZ;AAQY;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AANd;AAQY;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;AANd;AAUQ;EACE,eAAA;EACA,aAAA;AARV;AASU;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAPZ;AASU;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AAPZ;AAWM;EACE,aAAA;AATR;AAUQ;EACE,cAAA;EACA,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AARV;AASU;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AAPZ;AASU;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAPZ;AAUQ;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EAEA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AATV;AAUU;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AARZ;AAUU;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AARZ;AAaI;EAEE,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAZN;AAcM;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAZR;AAgBI;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAdN;AAeM;EACE,6BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AAbR;AAeM;EACE,8BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbR","sourcesContent":[".CandidateUpgradeCheckModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #000000b3;\n  backdrop-filter: blur(3px);\n  z-index: 1;\n  .UpgradeCheckContent {\n    background: var(--Foreground);\n    width: 35rem;\n    min-height: 20rem;\n    border-radius: 0.625rem;\n    padding: 0.75rem;\n    color: var(--TextColor);\n    position: relative;\n    overflow: hidden;\n    .UpgradeConvert {\n      text-align: center;\n      font-size: 1rem;\n      font-weight: 700;\n    }\n    p {\n      text-align: center;\n      font-size: 0.75rem;\n      padding-top: 0.3rem;\n      text-wrap: balance;\n    }\n    .UpgradeCurrentMain {\n      // background: #000000b3;\n      // height: 8rem;\n      border: 0.125rem solid var(--Stroke);\n      border-radius: 0.5rem;\n      display: flex;\n      justify-content: space-between;\n      padding: 1rem;\n      align-items: center;\n      margin-top: 1rem;\n      gap: 0.5rem;\n      .UpgradeCourt {\n        .UpgradeCurrentCheck {\n          text-align: center;\n          font-size: 0.6rem;\n        }\n        .UpgradeStandardCourt {\n          font-weight: 700;\n        }\n      }\n      // .UpgradeImage {\n      //   // background: greenyellow;\n      // }\n      .upgradeExpressCourt {\n        .UpgradeConvertedCheck {\n          text-align: center;\n          font-size: 0.6rem;\n        }\n        .UpgradeExpressCourt {\n          font-weight: 700;\n        }\n      }\n    }\n    .PaymentMet {\n      margin-top: 1.25rem;\n      display: flex;\n      flex-direction: column;\n      gap: 1.25rem;\n      .SplitAmount {\n        border: 0.0625rem solid var(--Stroke);\n        border-radius: 0.625rem;\n        .RefDetails {\n          display: flex;\n          padding: 0.625rem;\n          .ReferenceDetails {\n            flex: 1;\n            .Reference {\n              color: #9b9b9b;\n              font-size: 1rem;\n              font-weight: 600;\n            }\n\n            .ReferenceNumber {\n              color: Var(--TextColor);\n              font-size: 1rem;\n              font-weight: 600;\n              padding-left: 0.625rem;\n            }\n          }\n          .DateDetails {\n            .Date {\n              color: #9b9b9b;\n              font-size: 1rem;\n              font-weight: 600;\n            }\n\n            .DateNumber {\n              color: Var(--TextColor);\n              font-size: 1rem;\n              font-weight: 600;\n              padding-left: 0.625rem;\n            }\n          }\n        }\n        .TaxDetails {\n          border-top: 0.0625rem solid var(--Stroke);\n          padding: 0.625rem;\n          border-bottom: 0.0625rem solid var(--Stroke);\n          p {\n            display: flex;\n            padding: 0.25rem;\n            .Taxable {\n              flex: 1;\n              color: #9b9b9b;\n              font-size: 0.8rem;\n              font-weight: 300;\n            }\n            .TaxableAmt {\n              font-size: 0.8rem;\n              font-weight: 600;\n              color: var(--TextColor);\n            }\n          }\n        }\n        .AmtToPay {\n          padding: 0.5rem;\n          display: flex;\n          .AmountPay {\n            color: var(--TextColor);\n            flex: 1;\n            font-size: 1rem;\n            font-weight: 600;\n          }\n          .Amount {\n            color: var(--TextColor);\n            font-size: 1rem;\n            font-weight: 600;\n          }\n        }\n      }\n      .PaymentType {\n        display: flex;\n        .PaymentGateway {\n          width: 16.5rem;\n          height: 10rem;\n          border: 0.0625rem solid var(--Stroke);\n          border-radius: 0.625rem;\n          padding: 0.625rem;\n          display: flex;\n          align-items: center;\n          flex-direction: column;\n          gap: 1.25rem;\n          cursor: pointer;\n          .WalletPayAmt {\n            color: var(--TextColor);\n            font-size: 1rem;\n            font-weight: 600;\n          }\n          .PayViaWallet {\n            color: var(--AccentColor);\n            font-size: 1rem;\n            font-weight: 700;\n          }\n        }\n        .PayWallet {\n          width: 16.5rem;\n          height: 10rem;\n          margin-left: 0.5rem;\n          border: 0.0625rem solid var(--Stroke);\n          border-radius: 0.625rem;\n          padding: 0.625rem;\n          display: flex;\n          // justify-content: center;\n          align-items: center;\n          flex-direction: column;\n          gap: 1.25rem;\n          cursor: pointer;\n          .WalletPayAmt {\n            color: var(--TextColor);\n            font-size: 1rem;\n            font-weight: 600;\n          }\n          .PayViaWallet {\n            color: var(--AccentColor);\n            font-size: 1rem;\n            font-weight: 700;\n          }\n        }\n      }\n    }\n    .UpdatedCost {\n      // background: yellowgreen;\n      border: 0.125rem solid #cccad4;\n      border-radius: 0.5rem;\n      margin-top: 0.75rem;\n      padding: 0.75rem;\n      display: flex;\n      // justify-content: space-between;\n      p {\n        flex: 1;\n        text-align: left;\n        font-size: 0.75rem;\n        font-weight: 700;\n        // background-color: aqua;\n      }\n    }\n    .UpgradeButton {\n      margin-top: 1rem;\n      padding: 0.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 2rem;\n      .UpgradeCancel {\n        background: var(--Foreground);\n        border-radius: 0.25rem;\n        width: 6rem;\n        height: 2rem;\n        font-size: 0.75rem;\n        color: var(--TextColor);\n      }\n      .UpgradeConfirm {\n        background: var(--AccentColor);\n        border-radius: 0.25rem;\n        width: 6rem;\n        height: 2rem;\n        color: #ffff;\n        font-size: 0.75rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
